
export const dataProjects = [
  // {
  //   "title":"Project 1",
  //   "description":"a project with a background image",
  //   "image":"assets/project-assets/images/placeholder1.jpg",
  //   "asset":"assets/project-assets/pages/test.md",
  //   "webLocation":"project1",
  // },
  {
    "title":"Reasoning and learning for robotics",
    "description":"",
    "image":"assets/project-assets/webp-images/arm_farm.webp",
    "asset":"assets/project-assets/pages/reasoning-and-learning-for-robotics.md",
    "webLocation":"reasoning-and-learning-for-robotics",
  },
  {
    "title":"Safe robot learning",
    "description":"",
    "image":"assets/project-assets/webp-images/placeholder3.webp",
    "asset":"assets/project-assets/pages/safe-robot-learning.md",
    "webLocation":"safe-robot-learning",
  },
  {
    "title":"3D vision and generative models for simulation",
    "description":"",
    "image":"assets/project-assets/webp-images/freekick.webp",
    "asset":"assets/project-assets/pages/generative-models-and-perception.md",
    "webLocation":"generative-models-and-perception",
  },
  {
    "title":"Robotics for chemistry and biology lab automation",
    "description":"",
    "image":"assets/project-assets/webp-images/icra23-chemistry-tamp2.webp",
    "asset":"assets/project-assets/pages/robotics-for-chemistry-and-biology-lab-automation.md",
    "webLocation":"robotics-for-chemistry-and-biology-lab-automation",
  },
  {
    "title":"Field robotics \& environmental monitoring",
    "description":"",
    "image":"assets/project-assets/webp-images/placeholder1.webp",
    "asset":"assets/project-assets/pages/field-robotics.md",
    "webLocation":"field-robotics",
  },
  
  
]
